import React from 'react';
import { Link } from 'react-router-dom';
export default function Projects() {
  const projects = [
    {
      name: 'Kongu Mangai',
      category: 'Matrimonial Platform',
      icon: '💍',
      description:
        'A modern matrimonial platform designed to connect communities with secure profiles, smart matching, and responsive user experience.',
      technologies: ['React JS', 'Node JS', 'MySQL', 'Firebase'],
      website: 'https://kongumangai.com/'
    },
    {
      name: 'Create Learning',
      category: 'Educational Platform',
      icon: '🎓',
      description:
        'An online learning platform built for students and educational institutions with modern course management and responsive design.',
      technologies: ['React JS', 'Node JS', 'MySQL'],
      website: 'https://www.createlearning.in/'
    },
    {
      name: 'GJ Jewellery',
      category: 'Jewellery Ecommerce',
      icon: '💎',
      description:
        'A jewellery ecommerce website with elegant product showcases, enquiry management, and mobile-friendly shopping experience.',
      technologies: ['React Native', 'Node JS', 'MySQL', 'Express JS'],
      website: 'https://play.google.com/store/apps/details?id=com.gjjewellery'
    },
    {
      name: 'Regular Solution',
      category: 'Business Solutions',
      icon: '💼',
      description:
        'Professional business website developed with responsive layouts, service showcases, and lead generation features.',
      technologies: ['React Native', 'Node JS', 'MongoDB', 'Express JS'],
      website: 'https://play.google.com/store/apps/details?id=com.regularsolutionsuser'
    },
    {
      name: 'Senthanamuthan Kids Wear',
      category: 'Kids Fashion Ecommerce',
      icon: '🛍️',
      description:
        'An ecommerce platform for kids fashion products with modern UI, secure shopping experience, and responsive product catalog.',
      technologies: ['React JS', 'Firebase', 'MySQL', 'Tailwind CSS'],
      website: 'https://senthanamuthankidswear.shop/'
    },
    {
      name: 'Bravvo',
      category: 'Business & Ecommerce Platform',
      icon: '🚀',
      description:
        'A modern business branding and digital platform designed with responsive layouts, premium UI design, and professional business presentation features.',
      technologies: ['Laravel', 'MySQL', 'Bootstrap'],
      website: 'https://bravvo.in/'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="uppercase tracking-[3px] text-[#0a8082] font-semibold mb-4">
            Our Projects
          </p>

          <h2 className="text-5xl font-bold text-[#071E56] mb-6">
            Our Recent Works
          </h2>

          <p className="text-gray-600 text-lg leading-8 max-w-4xl mx-auto">
            Explore our successful projects and digital solutions delivered for businesses across multiple industries.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-[35px] overflow-hidden shadow-2xl border border-gray-100 hover:-translate-y-2 transition duration-500"
            >
              <div className="bg-gradient-to-r from-[#0a8082] to-[#071E56] p-10 text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>

                <div className="relative z-10 flex items-start justify-between gap-5">
                  <div>
                    <div className="w-24 h-24 rounded-[30px] bg-white/20 flex items-center justify-center text-6xl mb-6 shadow-xl backdrop-blur-md">
                      {project.icon}
                    </div>

                    <p className="uppercase tracking-[2px] text-sm text-gray-100 mb-3 font-semibold">
                      {project.category}
                    </p>

                    <h3 className="text-4xl font-bold leading-tight">
                      {project.name}
                    </h3>
                  </div>
                </div>
              </div>

              <div className="p-10">
                <p className="text-gray-600 text-lg leading-9 text-justify mb-10">
                  {project.description}
                </p>

                <div className="mb-10">
                  <h4 className="text-2xl font-bold text-[#071E56] mb-5">
                    Technologies Used
                  </h4>

                  <div className="flex flex-wrap gap-4">
                    {project.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        className="px-5 py-3 rounded-full bg-[#0a8082]/10 text-[#0a8082] font-semibold"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap gap-5">
                  <a
                    href={project.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white px-8 py-4 rounded-full font-bold hover:scale-105 transition duration-300 shadow-xl"
                  >
                    Visit the Link
                  </a>

                  <Link
                    to="/contact"
                    className="border border-[#0a8082] text-[#0a8082] px-8 py-4 rounded-full font-bold hover:bg-[#0a8082] hover:text-white transition duration-300"
                  >
                    Start Similar Project
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 bg-gradient-to-r from-[#071E56] via-[#0a8082] to-[#071E56] rounded-[40px] p-14 text-center text-white shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[radial-gradient(circle_at_top_right,_white,_transparent_40%)]"></div>

          <div className="relative z-10">
            <h2 className="text-5xl font-bold mb-6">
              Have A Project Idea?
            </h2>

            <p className="text-xl leading-9 max-w-4xl mx-auto mb-10 text-gray-100">
              Let's transform your business idea into a modern digital solution with innovative technologies and professional development services.
            </p>

            <div className="flex flex-wrap justify-center gap-5">
              <Link
                to="/contact"
                className="bg-white text-[#0a8082] px-10 py-4 rounded-full font-bold hover:scale-105 transition duration-300 shadow-xl"
              >
                Discuss Your Project
              </Link>

              <a
                href="https://wa.me/919487924282"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-white px-10 py-4 rounded-full font-bold hover:bg-white hover:text-[#0a8082] transition duration-300"
              >
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}